<template>
  <v-menu>
    <template #activator="{ props }">
      <v-tooltip v-bind="props" location="bottom center">
        <template #activator="{ props: tooltip }">
          <div v-bind="tooltip">
            <v-btn-icon
              icon="mdi-share-variant"
              v-bind="props"
              :class="[{ 'px-5': $vuetify.display.sm }, { 'px-4': $vuetify.display.xs }]"
              data-testid="publishPlayerItem.open-button"
              @click="playerDialog = true"
            >
            </v-btn-icon>
          </div>
        </template>
        <span>Publish Player</span>
      </v-tooltip>
    </template>
  </v-menu>
  <publish-player-dialog
    v-if="editorStateStore().getModelId && playerDialog"
    :statechart-name="statechartName"
    :model-id="editorStateStore().getModelId"
    :model="getModelAsJson(rappidContext.paper.model)"
    @close="playerDialog = false"
  ></publish-player-dialog>
</template>

<script setup lang="ts">
import { inject, ref } from "vue";
import PublishPlayerDialog from "./PublishPlayerDialog.vue";
import { editorStateStore } from "../../services/storage/editor-state-store";
import { getModelAsJson } from "../../services/model-helper";
import RappidContext from "../../rappid/rappid-context";

defineProps<{ statechartName: string }>();

const rappidContext: RappidContext = inject<RappidContext>("rappidContext");

const playerDialog = ref(false);
</script>

<style></style>
